export const education = [
  {
    school: "University of Toronto",
    degree: "Honours BSc, Computer Science + Mathematical Sciences (double major)",
    duration: "Expected April 2028",
    cgpa: "3.9",
    // The non-breaking space keeps the two years on one line
    honours: "Dean's List Scholar (2025,\u00a02026)",
    // Shown as one block of tags per group
    coursework: [
      {
        area: "Machine Learning & AI",
        courses: [
          "Machine Learning",
          "Neural Networks & Deep Learning",
          "Artificial Intelligence"
        ]
      },
      {
        area: "Systems & Software",
        courses: [
          "Operating Systems",
          "Introduction to Databases",
          "Software Design",
          "Computer Organization"
        ]
      },
      {
        area: "Theory & Algorithms",
        courses: [
          "Data Structures & Algorithms",
          "Computational Complexity",
          "Theory of Computation"
        ]
      },
      {
        area: "Mathematics",
        courses: [
          "Probability & Statistics",
          "Linear Algebra II",
          "Advanced Calculus",
          "Group Theory"
        ]
      }
    ]
  }
];
